import { Image, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import React from 'react';
import Item from './Item';
import './style.scss';

/**
 * This component has different variations defined by the contentLayout rendering param
 * which is selected by the content author.
 * renderVariation function applies different fields and layout according to each
 * contentLayout value
 */
const Taxonomy = ({ fields = {}, params }) => {
  const { items, leftImage, leftImageSubTitle, leftImageTitle, rightImage, subTitle, title } =
    fields;

  const contentLayout = params?.contentLayout?.toLowerCase();

  const shouldRenderItems = Array.isArray(items) && items?.length > 0;
  const shouldRenderLeftImage = !!leftImage?.value?.src;
  const shouldRenderLeftImageSubTitle = !!leftImageSubTitle?.value;
  const shouldRenderLeftImageTitle = !!leftImageTitle?.value;
  const shouldRenderRightImage = !!rightImage?.value?.src;
  const shouldRenderSubTitle = !!subTitle?.value;
  const shouldRenderTitle = !!title?.value;

  const renderVariation = () => {
    if (contentLayout === 'titleWithTwoEqualColumns'.toLowerCase()) {
      return (
        <div
          className={clsx(
            'taxonomy-content',
            contentLayout,
            params?.removeRedLine === '1' && 'remove-border'
          )}
        >
          {shouldRenderTitle && (
            <h2>
              <Text field={title} />
            </h2>
          )}
          {shouldRenderItems && (
            <div className="taxonomy-body row justify-content-center">
              {items.map((item, index) => {
                return <Item key={index} data={item?.fields} variation={contentLayout} />;
              })}
            </div>
          )}
        </div>
      );
    } else if (contentLayout === 'titleWithFourTextBlocks'.toLowerCase()) {
      return (
        <div className={clsx('taxonomy-content', contentLayout)}>
          {shouldRenderTitle && (
            <h2>
              <Text field={title} />
            </h2>
          )}
          {shouldRenderItems && (
            <div className="taxonomy-body row justify-content-center">
              {items.map((item, index) => {
                return <Item key={index} data={item?.fields} variation={contentLayout} />;
              })}
            </div>
          )}
        </div>
      );
    } else if (contentLayout === 'titleWithSubTitleAndTwoEqualColumns'.toLowerCase()) {
      return (
        <div
          className={clsx(
            'toxonomy-row row',
            contentLayout,
            params?.removeRedLine === '1' && 'remove-border'
          )}
        >
          <div className="col-12 col-md-2 toxonomy-row-left">
            {shouldRenderSubTitle && (
              <div className="toxonomy-subtitle">
                <Text field={subTitle} />
              </div>
            )}
          </div>
          <div
            className={clsx('taxonomy-content col-12 col-md-10 toxonomy-row-right', contentLayout)}
          >
            {shouldRenderTitle && (
              <h2>
                <Text field={title} />
              </h2>
            )}
            {shouldRenderItems && (
              <div className="taxonomy-body row justify-content-center">
                {items.map((item, index) => {
                  return <Item key={index} data={item?.fields} variation={contentLayout} />;
                })}
              </div>
            )}
          </div>
        </div>
      );
    } else if (contentLayout === 'withImages'.toLowerCase()) {
      return (
        <div
          className={clsx(
            'taxonomy-content',
            contentLayout,
            params?.removeRedLine === '1' && 'remove-border'
          )}
        >
          {shouldRenderSubTitle && (
            <div className="toxonomy-subtitle">
              <Text field={subTitle} />
            </div>
          )}
          {shouldRenderTitle && (
            <h2>
              <Text field={title} />
            </h2>
          )}
          {shouldRenderItems && (
            <div className="taxonomy-body row">
              {items.map((item, index) => {
                return <Item key={index} data={item?.fields} variation={contentLayout} />;
              })}
            </div>
          )}
          <div className="taxonomy-images row">
            <div className="toxonomy-left col-11 col-md-3">
              {shouldRenderLeftImage && <Image field={leftImage} />}
              <div className="toxonomy-left-content">
                {shouldRenderLeftImageTitle && (
                  <div className="left-content-title">
                    <Text field={leftImageTitle} />
                  </div>
                )}
                {shouldRenderLeftImageSubTitle && (
                  <div className="left-content-subtitle">
                    <Text field={leftImageSubTitle} />
                  </div>
                )}
              </div>
            </div>
            <div className="toxonomy-right col-12 col-md-9">
              {shouldRenderRightImage && <Image field={rightImage} />}
            </div>
          </div>
        </div>
      );
    } else if (contentLayout === 'titleWithThreeEqualColumns'.toLowerCase()) {
      return (
        <div className={clsx('taxonomy-content', contentLayout)}>
          {shouldRenderSubTitle && (
            <div className="toxonomy-subtitle">
              <Text field={subTitle} />
            </div>
          )}
          {shouldRenderTitle && (
            <h2>
              <Text field={title} />
            </h2>
          )}
          {shouldRenderItems && (
            <div className="taxonomy-body row">
              {items.map((item, index) => {
                return <Item key={index} data={item?.fields} variation={contentLayout} />;
              })}
            </div>
          )}
        </div>
      );
    } else if (contentLayout === 'titleWithTwoUnEqualColumns'.toLowerCase()) {
      return (
        <div className={clsx('toxonomy-row row', contentLayout)}>
          <div className="col-12 col-lg-4 toxonomy-row-left">
            {shouldRenderSubTitle && (
              <div className="toxonomy-subtitle">
                <Text field={subTitle} />
              </div>
            )}
            {shouldRenderTitle && (
              <h3>
                <Text field={title} />
              </h3>
            )}
          </div>
          <div className="col-12 col-lg-8 toxonomy-row-right">
            {shouldRenderItems && (
              <div className="taxonomy-body row">
                {items.map((item, index) => {
                  return <Item key={index} data={item?.fields} variation={contentLayout} />;
                })}
              </div>
            )}
          </div>
        </div>
      );
    } else if (contentLayout === 'onlyTitleAndSubTitle'.toLowerCase()) {
      return (
        <div className={clsx('taxonomy-content', contentLayout)}>
          {shouldRenderTitle && (
            <h3>
              <Text field={title} />
            </h3>
          )}
          {shouldRenderSubTitle && (
            <div className="toxonomy-subtitle">
              <Text field={subTitle} />
            </div>
          )}
        </div>
      );
    }
  };

  return (
    <div className={clsx('taxonomy-component content', 'add-margins', params?.Styles)}>
      {renderVariation()}
    </div>
  );
};

export default Taxonomy;
